export default __webpack_public_path__ + "static/media/n1.36bcf693.webp";